"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateEditor = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useInterface_1 = require("../../../hooks/useInterface");
var DateInput_1 = require("../../../components/DateInput");
exports.DateEditor = (0, react_1.forwardRef)(function (_a, ref) {
  var _b, _c;
  var value = _a.value,
    eGridCell = _a.eGridCell,
    dateFormat = _a.dateFormat,
    locale = _a.locale,
    api = _a.api;
  var _d = (0, DateInput_1.useDateInput)(value),
    date = _d.date,
    shown = _d.shown,
    valid = _d.valid,
    restProps = __rest(_d, ["date", "shown", "valid"]);
  (0, react_1.useEffect)(function () {
    var fn = function (e) {
      if (e.key === "Enter" && valid) {
        eGridCell.removeEventListener("keydown", fn);
        setTimeout(function () {
          return api.stopEditing();
        }, 0);
      }
    };
    eGridCell.addEventListener("keydown", fn);
  }, [eGridCell]);
  (0, useInterface_1.useInterface)(ref, {
    getValue: function () {
      return date;
    }
  });
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: "ag-cell-edit-wrapper"
  }, {
    children: (0, jsx_runtime_1.jsx)(DateInput_1.DateInput, __assign({}, restProps, {
      date: date,
      shown: shown,
      showIcon: false,
      valid: valid,
      locale: locale,
      dateFormat: dateFormat,
      popoverProps: {
        appendTo: (_c = (_b = eGridCell.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) !== null && _c !== void 0 ? _c : document.body,
        wrapperProps: {
          style: {
            width: "100%",
            left: 0
          }
        }
      },
      startFocused: true,
      clearable: false
    }))
  }));
});